export default __webpack_public_path__ + "static/media/It-had-to-happen_web.d6ad1bec.jpg";